import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AsRomaLanding from "@/pages/AsRomaLanding";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AsRomaLanding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
